import { SET_UTILITY_INPUTS_IS_VISIBLE } from './constants';

export const setUtilityInputsIsVisible = isVisible => ({
    type: SET_UTILITY_INPUTS_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/actions.js